var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-image-preview',{attrs:{"showIndex":true,"images":_vm.images},on:{"change":_vm.handleChangeIndex},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('template',{slot:"cover"},[_c('div',{staticClass:"img-preview-box"},[_c('div',{staticClass:"img-preview-footer"})])])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }